import React from "react";

export default function GlassPanel({ className = "", children, reticle = false, scanline = false, ...rest }) {
  return (
    <div
      className={`gps-glass ${reticle ? "gps-reticle" : ""} ${scanline ? "gps-scanline" : ""} ${className}`}
      {...rest}
    >
      {reticle && (
        <>
          <span className="ret-tr" /><span className="ret-bl" />
        </>
      )}
      {children}
    </div>
  );
}
